<template>
  <div>
    <h5 class="mb-3">{{ $t('repassword.title') }}</h5>
    <div v-if="registration && registration.failure" class="alert alert-danger">
      {{registration.message.text}}.
    </div>
    <form @submit.prevent="handleSubmit">
      <div class="mb-3">
        <label class="form-label" for="repassword-email">Email</label>
        <input
          id="repassword-email"
          class="form-control"
          type="email"
          name="email"
          v-model="email"
        />
      </div>
      <button class="btn btn-primary w-100">{{ $t('repassword.submit') }}</button>
      <div class="d-flex justify-content-between mt-3 small">
        <button
          type="button"
          class="btn btn-link btn-sm p-0"
          @click="switchMode('login')"
        >{{ $t('registration.login') }}</button>
        <button
          type="button"
          class="btn btn-link btn-sm p-0"
          @click="switchMode('register')"
        >{{ $t('login.register') }}</button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: ""
    };
  },
  computed: {
    registration() {
      return this.$store.state.auth.registration;
    }
  },
  methods: {
    handleSubmit() {
      if (this.email) {
        this.$store.dispatch("auth/register", {
          email: this.email,
          userType: "user",
          repassword: true
        });
      }
    },
    switchMode(mode) {
      this.$emit("changeMode", mode);
    }
  }
};
</script>